/* Inéa V4 — configurateur produit en 3 étapes (inhalateur inclus, pack, saveurs).
   Repris du script de la maquette inea-produit.html ; l'ajout au panier passe par /cart/add.js
   avec les saveurs en propriété de ligne. Les données viennent du JSON rendu par sections/iv4-product.liquid. */
(function () {
  var CHECK = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.2l2.3 2.3L9.5 3.8" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html !== undefined) e.innerHTML = html; return e; }
  function sum(obj) { var t = 0; for (var k in obj) { t += obj[k]; } return t; }
  // « 39,99 € » → 39.99 ; coût par recharge = prix / (sachets × 3), 1 sachet = 3 recharges (CHARTE.md).
  function parsePrice(s) { var m = String(s || '').replace(/\s/g, '').replace(',', '.').match(/[0-9]+(\.[0-9]+)?/); return m ? parseFloat(m[0]) : NaN; }
  function euros(v) { return v.toFixed(2).replace('.', ',') + '\u00a0€'; }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Périodes de promotion des packs, en heure de Paris (« AAAA-MM-JJ HH:MM »).
  // ?iv4_date=AAAA-MM-JJ simule une date, uniquement sur un thème non publié (aperçu).
  function parisOffset(ms) {
    try {
      var v = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Paris', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        .formatToParts(new Date(ms)).forEach(function (x) { v[x.type] = parseInt(x.value, 10); });
      return Date.UTC(v.year, v.month - 1, v.day, v.hour, v.minute, v.second) - ms;
    } catch (e) { return 3600000; }
  }
  function parseParis(str) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})[:h](\d{2}))?\s*$/.exec(str || '');
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    return guess - parisOffset(guess);
  }
  var NOW = Date.now();
  try {
    var sim = new URLSearchParams(window.location.search).get('iv4_date') || window.IV4_PREVIEW_DATE;
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    if (sim && role && role !== 'main' && !isNaN(parseParis(sim))) NOW = parseParis(sim.length <= 10 ? sim + ' 12:00' : sim);
  } catch (e) {}

  function init(root) {
    if (root.__iv4) return;
    root.__iv4 = true;
    var cfgEl = root.querySelector('[data-iv4-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var PACKS = (cfg.packs || []).filter(function (p) {
      var a = parseParis(p.promoStart), b = parseParis(p.promoEnd);
      p.promoOn = !isNaN(a) && !isNaN(b) && NOW >= a && NOW < b;
      return !(p.promoOnly && !p.promoOn);
    });
    var FLAVORS = cfg.flavors || [];
    if (!PACKS.length) return;

    var IMG = {}, COLORS = {}, ORDER = [];
    FLAVORS.forEach(function (f) { IMG[f.name] = f.img; COLORS[f.name] = f.color; ORDER.push(f.name); });
    var FAMILIES = (cfg.families || []).map(function (fam) {
      return { id: fam.id, name: fam.name, list: FLAVORS.filter(function (f) { return f.family === fam.id; }).map(function (f) { return f.name; }) };
    }).filter(function (fam) { return fam.list.length > 0; });
    PACKS.forEach(function (p) {
      p.n = parseInt(p.n, 10) || 1;
      p.imgs = (p.imgs || []).map(function (s) { return String(s).trim(); }).filter(function (s) { return IMG[s]; }).slice(0, 3);
    });

    function $(ref) { return root.querySelector('[data-ref="' + ref + '"]'); }
    function packBy(code) { for (var i = 0; i < PACKS.length; i++) { if (PACKS[i].code === code) return PACKS[i]; } return null; }

    var urlPack = null;
    try { urlPack = new URLSearchParams(window.location.search).get('pack'); } catch (e) {}
    var start = packBy(urlPack) || packBy(cfg.defaultPack) || PACKS[Math.min(1, PACKS.length - 1)];

    var state = { pack: start.code, mode: 'disc', family: FAMILIES.length ? FAMILIES[0].id : null, free: {}, busy: false };

    function pack() { return packBy(state.pack) || PACKS[0]; }
    function family() { for (var i = 0; i < FAMILIES.length; i++) { if (FAMILIES[i].id === state.family) return FAMILIES[i]; } return FAMILIES[0]; }

    // Composition libre de départ : les sachets illustrés du pack, répartis comme en mode Découverte (Menthe 2, Fraise 2, Orange 2 pour 6).
    (function seedFree() {
      var names = start.imgs.length ? start.imgs : ORDER.slice(0, 3);
      var base = Math.floor(start.n / names.length), rest = start.n % names.length;
      names.forEach(function (name, i) { var q = base + (i < rest ? 1 : 0); if (q > 0) state.free[name] = q; });
    })();

    function discCounts() {
      var f = family(), n = pack().n, out = {};
      if (!f) return out;
      var len = f.list.length, base = Math.floor(n / len), rest = n % len;
      f.list.forEach(function (name, i) { out[name] = base + (i < rest ? 1 : 0); });
      return out;
    }
    function counts() { return state.mode === 'disc' ? discCounts() : state.free; }
    function ready() { return sum(counts()) === pack().n; }

    // Galerie en carrousel : défilement horizontal avec aimantation, flèches, miniatures et points synchronisés.
    function renderGallery() {
      var g = root.querySelector('[data-g-root]'); if (!g) return;
      var track = g.querySelector('.g-track'), slides = track.querySelectorAll('.g-slide');
      var thumbs = root.querySelectorAll('.thumbs button'), dots = [], cur = root.querySelector('[data-g-cur]');
      var n = slides.length, idx = 0;
      var lock = 0;
      function go(i) { idx = (i + n) % n; mark(idx); lock = Date.now(); track.scrollTo({ left: slides[idx].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); }
      function mark(i) {
        idx = i;
        Array.prototype.forEach.call(thumbs, function (t, k) { t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('on', k === i); });
        if (cur) cur.textContent = i + 1;
        var t = thumbs[i]; if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
      }
      var tm; track.addEventListener('scroll', function () {
        clearTimeout(tm); tm = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (Date.now() - lock < 1200 && i !== idx) return; mark(i); }, 80);
      }, { passive: true });
      Array.prototype.forEach.call(root.querySelectorAll('.gallery .g-nav'), function (b) { b.addEventListener('click', function () { go(idx + parseInt(b.getAttribute('data-g'), 10)); }); });
      Array.prototype.forEach.call(thumbs, function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-i'), 10)); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(idx + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(idx - 1); e.preventDefault(); }
      });
      // Souris : glisser pour changer de photo (le tactile utilise le défilement natif).
      var x0 = null;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') x0 = e.clientX; });
      window.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); });
    }

    function renderPacks() {
      var box = $('packs'); box.innerHTML = '';
      PACKS.forEach(function (p) {
        var b = el('button', 'opt' + (p.promoOnly ? ' opt-wide' : '')); b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', p.code === state.pack ? 'true' : 'false');
        var html = '';
        if (p.badge) html += '<span class="badge' + (p.light ? ' light' : '') + '">' + esc(p.badge) + '</span>';
        html += '<span class="stackimg">' + p.imgs.map(function (k) { return '<img src="' + esc(IMG[k]) + '" alt="" loading="lazy">'; }).join('') + '</span>';
        html += '<span class="opt-big">' + esc(p.title) + '</span><span class="opt-sub">' + esc(p.sub) + '</span>';
        html += '<span class="opt-price">' + esc(p.price) + '</span>';
        if (p.was || p.save) html += '<span class="opt-line">' + (p.was ? '<span class="opt-was">' + esc(p.was) + '</span>' : '') + (p.save ? '<span class="opt-save">' + esc(p.save) + '</span>' : '') + '</span>';
        var unit = parsePrice(p.price) / (p.n * 3);
        if (isFinite(unit)) html += '<span class="opt-unit">soit ' + euros(unit) + ' la recharge</span>';
        if (p.promoOn && p.promoGift) html += '<span class="opt-gift"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>' + esc(p.promoGift) + '</span>';
        b.innerHTML = html;
        b.addEventListener('click', function () { selectPack(p.code); });
        box.appendChild(b);
      });
    }

    function selectPack(code) {
      state.pack = code;
      var n = pack().n, t = sum(state.free);
      if (t > n) {
        var keys = Object.keys(state.free).reverse();
        for (var i = 0; i < keys.length && t > n; i++) {
          while (state.free[keys[i]] > 0 && t > n) { state.free[keys[i]]--; t--; }
          if (state.free[keys[i]] === 0) delete state.free[keys[i]];
        }
      }
      clearAdded();
      renderPacks(); renderFlavors(); renderSummary();
    }

    function renderFamilies() {
      var box = $('families'); box.innerHTML = '';
      FAMILIES.forEach(function (f) {
        var b = el('button', 'fam'); b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', f.id === state.family ? 'true' : 'false');
        b.innerHTML = '<span class="check">' + CHECK + '</span><span class="dots">' + f.list.map(function (k) { return '<span style="background:' + esc(COLORS[k]) + '"></span>'; }).join('') + '</span><strong>' + esc(f.name) + '</strong><small>' + esc(f.list.join(', ')) + '</small>';
        b.addEventListener('click', function () { state.family = f.id; clearAdded(); renderFamilies(); renderFlavors(); renderSummary(); });
        box.appendChild(b);
      });
    }

    function renderFlavors() {
      var c = counts(), n = pack().n, fam = family();
      $('mixTitle').textContent = (cfg.discPrefix || '') + (fam ? ' ' + fam.name : '');
      $('mixCount').textContent = n + ' sachet' + (n > 1 ? 's' : '');
      var disc = $('mixDisc'); disc.innerHTML = '';
      if (fam) {
        fam.list.forEach(function (name) {
          var t = el('div', 'tile on');
          t.style.setProperty('--c', COLORS[name] || '#1E4630');
          t.innerHTML = '<div class="pick" style="cursor:default"><img src="' + esc(IMG[name]) + '" alt=""><span class="name">' + esc(name) + '</span></div><span class="count">×' + (c[name] || 0) + '</span>';
          disc.appendChild(t);
        });
      }

      var free = $('mixFree'); free.innerHTML = '';
      var t = sum(state.free);
      ORDER.forEach(function (name) {
        var q = state.free[name] || 0;
        var tile = el('div', 'tile' + (q > 0 ? ' on' : ''));
        tile.style.setProperty('--c', COLORS[name] || '#1E4630');
        tile.setAttribute('data-name', name);
        var pick = el('button', 'pick'); pick.type = 'button';
        pick.setAttribute('aria-label', 'Ajouter un sachet ' + name + (q > 0 ? ' (' + q + ' choisi' + (q > 1 ? 's' : '') + ')' : ''));
        pick.innerHTML = '<img src="' + esc(IMG[name]) + '" alt=""><span class="name">' + esc(name) + '</span>';
        pick.addEventListener('click', function () {
          if (sum(state.free) >= pack().n) { flash(); return; }
          state.free[name] = (state.free[name] || 0) + 1; state.bump = name; clearAdded(); renderFlavors(); renderSummary();
          var again = free.querySelector('[data-name="' + name.replace(/"/g, '') + '"] .pick'); if (again) again.focus();
        });
        var minus = el('button', 'minus', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Retirer un sachet ' + name);
        minus.addEventListener('click', function () {
          if (!state.free[name]) return;
          state.free[name]--; if (state.free[name] === 0) delete state.free[name];
          clearAdded(); renderFlavors(); renderSummary();
        });
        var cnt = el('span', 'count' + (state.bump === name && !reduceMotion ? ' bump' : ''), '×' + q);
        cnt.setAttribute('aria-hidden', 'true');
        tile.appendChild(pick); tile.appendChild(minus); tile.appendChild(cnt);
        free.appendChild(tile);
      });
      state.bump = null;
      var st = $('freeStatus'), rem = n - t;
      $('barFill').style.width = Math.min(100, Math.round(t / n * 100)) + '%';
      st.textContent = rem > 0 ? t + '/' + n + ' · encore ' + rem + ' à choisir' : t + '/' + n + ' · sélection complète';
      st.className = rem > 0 ? 'warn' : 'ok';
    }

    function flash() {
      var st = $('freeStatus'); st.textContent = 'Votre pack est complet. Retirez un sachet ou passez au pack supérieur.'; st.className = 'warn';
    }

    function renderSummary() {
      var p = pack(), c = counts(), t = sum(c);
      $('sum2').textContent = p.title + ' · ' + p.sub + ' · ' + p.price;
      var parts = []; for (var k in c) { if (c[k] > 0) parts.push(k + ' ×' + c[k]); }
      $('sum3').textContent = parts.length ? parts.join(' · ') : 'Choisissez vos saveurs';
      $('count3').innerHTML = t + '/' + p.n + '<small>sachets choisis</small>';
      $('count3').className = 'step-count ' + (t === p.n ? 'ok' : 'warn');
      $('ctaPrice').textContent = p.price;
      var cta = $('cta');
      if (ready()) { $('ctaLabel').textContent = cfg.ctaLabel || 'Ajouter au panier'; cta.setAttribute('aria-disabled', 'false'); }
      else { var r = p.n - t; $('ctaLabel').textContent = 'Choisissez encore ' + r + ' saveur' + (r > 1 ? 's' : ''); cta.setAttribute('aria-disabled', 'true'); }
      $('stickyName').textContent = p.name + ' · ' + p.title;
      $('stickyPrice').textContent = p.price;
      if ($('headPrice')) {
        $('headPrice').textContent = p.price;
        $('headWas').textContent = p.was || ''; $('headWas').hidden = !p.was;
        $('headSave').textContent = p.save || ''; $('headSave').hidden = !p.save;
        $('headSub').textContent = p.name + ' · ' + p.sub;
      }
      $('stickyCta').textContent = ready() ? (cfg.stickyLabel || 'Ajouter au panier') : 'Choisir mes saveurs';
    }

    function setMode(m) {
      state.mode = m;
      $('modeDisc').setAttribute('aria-pressed', m === 'disc' ? 'true' : 'false');
      $('modeFree').setAttribute('aria-pressed', m === 'free' ? 'true' : 'false');
      $('discView').hidden = m !== 'disc';
      $('freeView').hidden = m !== 'free';
      clearAdded();
      renderFlavors(); renderSummary();
    }

    function clearAdded() { var a = $('added'); a.className = 'added'; a.textContent = ''; }
    function showAdded(html, isError) { var a = $('added'); a.innerHTML = html; a.className = 'added show' + (isError ? ' is-error' : ''); }

    $('modeDisc').addEventListener('click', function () { setMode('disc'); });
    $('modeFree').addEventListener('click', function () { setMode('free'); });

    Array.prototype.forEach.call(root.querySelectorAll('.step'), function (s) {
      var head = s.querySelector('.step-head'), body = s.querySelector('.step-body');
      head.addEventListener('click', function () {
        var open = s.getAttribute('data-open') !== 'true';
        s.setAttribute('data-open', open ? 'true' : 'false');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
      });
    });

    $('cta').addEventListener('click', function () {
      if (state.busy) return;
      if (!ready()) {
        var s3 = root.querySelector('.step[data-step="3"]');
        if (s3.getAttribute('data-open') !== 'true') s3.querySelector('.step-head').click();
        setMode('free'); return;
      }
      var p = pack(), c = counts(), parts = [], cartParts = [];
      for (var k in c) { if (c[k] > 0) { parts.push(c[k] + ' × ' + k); cartParts.push(k + ' ×' + c[k]); } }

      var id = parseInt(String(p.variant || '').replace(/\D/g, ''), 10);
      if (!id) {
        showAdded(cfg.designMode
          ? 'Ce pack n\'est relié à aucune variante : renseignez son « ID de variante » dans l\'éditeur de thème.'
          : 'Ce pack n\'est pas encore disponible à la commande.', true);
        return;
      }

      var props = {}; props[cfg.propertyName || 'Saveurs'] = cartParts.join(', ');
      if (p.promoOn && p.promoGift) props[p.promoName || 'Cadeau'] = p.promoGift;
      var cta = $('cta');
      state.busy = true; cta.setAttribute('aria-busy', 'true');
      fetch(cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Ajout impossible');
          if (cfg.afterAdd === 'cart') { window.location.href = cfg.cartUrl; return null; }
          showAdded(esc(p.name) + ' ajouté au panier : ' + esc(parts.join(', ')) + '. <a href="' + esc(cfg.cartUrl) + '">Voir le panier</a>');
          return fetch(cfg.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('iv4:cart-updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('iv4:cart-added', { detail: cart }));
          }
        })
        .catch(function (err) { showAdded('Impossible d\'ajouter ce pack au panier : ' + esc(err.message), true); })
        .then(function () { state.busy = false; cta.removeAttribute('aria-busy'); });
    });

    // Date d'expédition : aujourd'hui + délai, reportée au lundi si elle tombe un week-end (comme la maquette).
    if ($('shipDate')) {
    var d = new Date(); d.setDate(d.getDate() + (parseInt(cfg.shipDays, 10) || 2));
    if (d.getDay() === 6) d.setDate(d.getDate() + 2); else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    try { $('shipDate').textContent = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { $('shipDate').textContent = d.getDate() + '/' + (d.getMonth() + 1); }
    }

    // Barre collante : visible dès que le bouton principal n'est plus à l'écran ; elle ajoute directement au panier.
    var sticky = $('stickyBuy');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting;
          sticky.classList.toggle('show', show);
          document.body.classList.toggle('iv4-sticky-on', show && window.matchMedia('(max-width: 900px)').matches);
        });
      }).observe($('cta'));
    }
    $('stickyCta').addEventListener('click', function () {
      if (ready()) { $('cta').click(); return; }
      root.querySelector('.step[data-step="3"]').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      $('cta').click();
    });

    renderGallery(); renderPacks(); renderFamilies(); renderFlavors(); renderSummary();
  }

  function boot() { document.querySelectorAll('[data-iv4-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-iv4-pdp]'); if (r) init(r);
  });
})();
